import { useTheme } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ErrorLogo from './bulbs.svg';
import { reportErrorToDynatrace } from './CustomBootErrorPage';

export function CustomNotFoundErrorPage() {
  const theme = useTheme();
  useEffect(() => {
    reportErrorToDynatrace('404 error message from pdp');
  }, []);
  return (
    <Grid container spacing={2} style={{ maxWidth: '100%', padding: '5%' }}>
      <Grid item sm={12} md={5}>
        <Typography variant="body1">Error 404</Typography>
        <Typography variant="h2" style={{ fontSize: '68px' }}>
          Well, that's puzzling!
        </Typography>
        <Typography style={{ fontSize: '20px', paddingTop: '20px' }}>
          We're sorry. It looks like the link you followed may be broken or the
          page may have been moved.
        </Typography>
        <Typography style={{ paddingTop: '25px', fontWeight: 700 }}>
          <Link
            to="/"
            style={{ borderBottom: `2px dashed ${theme.palette.textContrast}` }}
          >
            Visit the homepage
          </Link>
        </Typography>
      </Grid>
      <Grid item sm={12} md={7}>
        <img
          src={ErrorLogo}
          alt=""
          style={{ maxWidth: '100%', paddingTop: '90px' }}
        />
      </Grid>
    </Grid>
  );
}
